

export const Users = [
    {
      id: 1,
      name: "Janet Stephen",
      username: "janet_22",
      email: "amit@logan.tv",
      profilePicture:"/assets/person/pp1.jpeg",
    },
    {
      id: 2,
      name: "Isabella Randy",
      username: "isabel_23",
      email: "isabella@randy.biz",
      profilePicture: "/assets/person/pp2.jpeg",
    },
    {
      id: 3,
      name: "Beverly Bruce",
      username: "beverly_24",
      email: "Sherwood@rosamond.me",
      profilePicture: "/assets/person/pp3.jpeg",
    },
    {
      id: 4,
      name: "Glenna Philip",
      username: "glenna_25",
      email: "Chaim_McDermott@dana.io",
      profilePicture: "/assets/person/pp4.jpeg",
    },
    // {
    //   id: 5,
    //   name: "Clementina Sean",
    //   username: "Alexis",
    //   email: "Rey.Padberg@karina.biz",
    //   profilePicture: "/assets/person/person5.jpg",
    // },
  ];
  export const Usersonline = [
    {
      id: 1,
      name: "Leanne Graham",
      username: "Gloria",
      email: "Sincere@april.biz",
      profilePicture: "/assets/person/f1.jpeg",
    },
    {
      id: 2,
      name: "Ervin Howell",
      username: "Madison",
      email: "Shanna@melissa.tv",
      profilePicture: "/assets/person/f2.jpeg",
    },
    {
      id: 3,
      name: "Clementine Bauch",
      username: "Abigail",
      email: "Nathan@yesenia.net",
      profilePicture: "/assets/person/f3.jpeg",
    },
    {
      id: 4,
      name: "Patricia Lebsack",
      username: "Sophia",
      email: "Julianne.OConner@kory.org",
      profilePicture: "/assets/person/f4.jpeg",
    },
    {
      id: 5,
      name: "Chelsey Dietrich",
      username: "Marilyn",
      email: "Lucio_Hettinger@annie.ca",
      profilePicture: "/assets/person/f5.jpeg",
    },
    {
      id: 6,
      name: "Mrs. Dennis Schulist",
      username: "Doris",
      email: "Karley_Dach@jasper.info",
      profilePicture: "/assets/person/f6.jpeg",
    },
    {
      id: 7,
      name: "Kurtis Weissnat",
      username: "Rachel",
      email: "Telly.Hoeger@billy.biz",
      profilePicture: "/assets/person/f7.jpeg",
    },
    {
      id: 8,
      name: "Nicholas Runolfsdottir V",
      username: "Victoria",
      email: "Sherwood@rosamond.me",
      profilePicture: "/assets/person/f8.jpeg",
    },
    {
      id: 9,
      name: "Catherine",
      username: "Maria",
      email: "Chaim_McDermott@dana.io",
      profilePicture: "/assets/person/f9.jpeg",
    },
    {
      id: 10,
      name: "Clementina DuBuque",
      username: "Theresa",
      email: "Rey.Padberg@karina.biz",
      profilePicture: "/assets/person/f10.jpeg",
    },
    {
      id: 11,
      name: "Sharon Mattew",
      username: "Charlotte",
      email: "Rey.Padberg@karina.biz",
      profilePicture: "/assets/person/f11.jpeg",
    },
  ];
  
  export const Posts = [
    {
      userId: 3,
      id: 1,
      title: "to make a blinded choice to reject or provident to task",
      body: "because he receives and accepts the accepted consequences unencumbered and when he finds the discomfort",
      photo: "/assets/posts/p1.jpeg",
      date: "5 mins ago",
      like: "100",
      comment: "70",
    },
    {
      userId: 2,
      id: 2,
      title: "who is to be",
      body: "it is the time of life to pursue the things that are to be blamed for the pain of a blessed one, nor avoid the pleasures of flattery.",
      photo: "/assets/posts/p2.jpeg",
      date: "23 mins ago",
      like: "480",
      comment: "112",
    },
    {
      userId: 1,
      id: 3,
      title: "abuse her as an exercise in who she or she is",
      body: "and the just, but blinded by the pleasure of every right to choose, or for the pleasure of the pains or the accusers, who can bear the annoyances of his hatred and labor and desire",
      photo: "/assets/posts/p3.jpeg",
      date: "10 hours ago",
      like: "10",
      comment: "30",
    },
  
    {
      userId: 3,
      id: 4,
      title: "he is blinded",
      body: "to obtain any pleasure by rejecting one's love and often taking care of things is a fault\nobody is bound by this advantage, they do not know the thing and pain itself is right\nobody wants that pleasure of things",
      photo: "/assets/posts/p4.jpeg",
      date: "23 hours ago",
      like: "10",
      comment: "30",
    },
    {
      userId: 4,
      id: 5,
      title: "know how to hate",
      body: "to be rejected is to seek pardon but to be rejected or to shun",
      photo: "/assets/posts/p5.jpeg",
      date: "2 days ago",
      like: "560",
      comment: "200",
    },
    {
      userId: 2,
      id: 6,
      title: "I will open them for my great sorrow",
      body: "so that no one will reject the body of these women who provide us with a softness to follow, and no one will find fault with those accusing us of whatever pains he desires, and the pain of annoyance",
      photo: "/assets/posts/p6.jpeg",
      date: "2 days ago",
      like: "130",
      comment: "31",
    },
    {
      userId: 1,
      id: 7,
      title: "great but easy",
      body: "the pain may please some people in the life where it is important, for who who, by whom no one, or whom no one will often drive back, will receive them as because they want to follow them, but which they are",
      photo: "/assets/posts/p7.jpeg",
      date: "2 weeks ago",
      like: "10",
      comment: "30",
    },
    {
      userId: 4,
      id: 8,
      title: "pain is the actual pain",
      body: "I will open the pain to those who are worthy of being easily accepted by some minds who are able to be able to receive great things when there has never been greater",
      photo: "/assets/posts/p8.jpeg",
      date: "3 weeks ago",
      like: "780",
      comment: "412",
    },
    {
      userId: 1,
      id: 9,
      title: "know the right time and the pain of all the accusers",
      body: "",
      photo: "/assets/posts/p9.jpeg",
      date: "2 months ago",
      like: "10",
      comment: "3",
    },
    {
      userId: 2,
      id: 10,
      title: "choice that's annoying for him",
      body: "in which manner and unencumbered with the duties or great sorrows which must be repudiated, unless there be truly any pardon which but we accuse the error of the truth",
      photo: "/assets/posts/p10.jpeg",
      date: "4 months ago",
      like: "86",
      comment: "12",
    },
    {
      userId: 3,
      id: 11,
      title: "and it is true for those who praise it",
      body: "the choices we reject, when blinded by the annoyances, will come to pass, not least those who fall into pleasures will be happy in him, or those who do not enjoy pleasures as well as those who fall into the nut of the mind's advantage",
      photo: "/assets/posts/p11.jpeg",
      date: "1 year ago",
      like: "1000",
      comment: "340",
    },
    {
      userId: 1,
      id: 12,
      title: "at some time hate is pain",
      body: "so that's either great for the present because it hates them and it is pleasure and the wise because they love nothing, blinded because that pleasure is the distinction between hatred",
      photo: "/assets/posts/p12.jpeg",
      date: "1 year ago",
      like: "760",
      comment: "500",
    },
    {
      userId: 2,
      id: 13,
      title: "pain as a tenderness and often pleasure in the mind",
      body: "or may we be called the softness of the pleasure of the advantage with which the pain has been corrupted by rejecting the pleasure of the world",
      photo: "/assets/posts/p13.jpeg",
      date: "10 hours ago",
      like: "10",
      comment: "30",
    },
    {
      userId: 4,
      id: 14,
      title: "pleasure of choosing option",
      body: "flight and accusing us of enduring pains is pleasure and pain, nor do we",
      photo: "/assets/posts/p14.jpeg",
      date: "1 year ago",
      like: "48",
      comment: "7",
    },
  ];
  const updatedPosts = Posts.map(post => ({
    ...post,
    photo: `http://localhost:3000${post.photo}`,
  }));
  
  console.log(updatedPosts);